// extracted by mini-css-extract-plugin
export default {"card":"preference-card_card__zt9xD","cardHeader":"preference-card_cardHeader__jHxpD","hint":"preference-card_hint__IONej","cardBody":"preference-card_cardBody__z6GNI"};